import React,{Component} from 'react';
import {Link} from 'react-router-dom';

import {Header} from '../header/Header';
import {Footer} from '../footer/Footer';

export class Activites extends Component{
    render(){
        return(
            <>
            <Header></Header>
            <br/> 
            <br/>
            <br/>
            <div className="container">
                <h2>Board of Intermediate Education Karachi</h2>
                <h3>Picture Gallery</h3>
                <ul>
                    <li><a href="https://firebasestorage.googleapis.com/v0/b/biek-edu.appspot.com/o/WhatsApp%20Image%202018-04-11%20at%201.55.08%20PM.jpeg?alt=media&token=65014d94-3298-4e84-b809-fcf8740ba366" target="_blank">Instructions regarding Annual Examinations 2018</a></li>
                    <li><a href="https://firebasestorage.googleapis.com/v0/b/biek-edu.appspot.com/o/WhatsApp%20Image%202018-04-11%20at%201.56.53%20PM.jpeg?alt=media&token=5b89139a-799c-4bc0-865d-2c916a5fa4a1" target="_blank">Award Distribution to the students</a></li>
                    <li><a href="https://firebasestorage.googleapis.com/v0/b/biek-edu.appspot.com/o/WhatsApp%20Image%202018-04-11%20at%201.56.54%20PM.jpeg?alt=media&token=9537c8d9-0aaf-4803-8836-ca1085dc4708" target="_blank">Life Time Award given by Chairman BIE, Karachi</a></li>

                </ul>
            </div>
            <br/>
            <br/>
            <br/>
            <Footer></Footer>
            </>
        )
    }
}